import React, { useMemo } from "react";
import { TileLayer, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import { normaliseTenementFeatureData, onEachFeature } from "../utils/geoJsonHelpers";
import { createTenementsTileUrl } from "../utils/tenementsGeoServer.js";

const MapLayers = ({ layers, geojson, tenementsLayerVisible, offlineCoastline, selectedTenement }) => {
  const mapWorldStyle = useMemo(
    () => (feature) => ({
      fillOpacity: 1.0,
      fillColor: "#f2efe9",
      color: "#aaaaaa",
      weight: 1,
    }),
    []
  );

  // Define style for GeoJSON features
  const styleFeature = useMemo(
    () => (feature) => {
      if (feature.properties && feature.properties.hasOwnProperty("_INVENTUM_GROUP")) {
        return {
          color: feature.properties._INVENTUM_GROUP === "ADDED" ? "#FF0000" : "#00FF00",
        };
      }
      return null;
    },
    []
  );

  const showDefaultVector = layers.length === 0 && offlineCoastline !== null;
  const showSingleGeoJSON = geojson && !Array.isArray(geojson) && Object.keys(geojson).length > 0;
  const geojsonLayers = Array.isArray(geojson) ? geojson : [];
  const selectedTenementData = useMemo(() => normaliseTenementFeatureData(selectedTenement), [selectedTenement]);

  return (
    <>


      {/* Offline fallback coastline */}
      {/* {showDefaultVector && <GeoJSON style={mapWorldStyle} data={offlineCoastline} pane="basePane" zIndex={10} />} */}

      {/* Dynamic tile layers from configuration */}
      {layers.map((layer) => layer && React.cloneElement(layer, { pane: "tilePane" }))}

      {/* GeoJSON data when present */}
      {showSingleGeoJSON && (
        <GeoJSON
          style={styleFeature}
          key={hash(geojson)}
          pane="overlayPane"
          zIndex={320}
          onEachFeature={(feature, layer) => onEachFeature(feature, layer, false)}
          data={geojson}
        />
      )}

      {/* Tenements layer */}
      {tenementsLayerVisible && (
        <TileLayer
          zIndex={350}
          pane="overlayPane"
          url={createTenementsTileUrl()}
          tms={true}
          minZoom={0}
          maxZoom={13}
          noWrap={true}
        />
      )}

      {/* Handle array of GeoJSON objects */}
      {geojsonLayers.map((gj) => (
        <GeoJSON
          style={styleFeature}
          key={hash(gj)}
          pane="overlayPane"
          zIndex={320}
          onEachFeature={(feature, layer) => onEachFeature(feature, layer, false)}
          data={gj}
        />
      ))}

      {/* Selected tenement with popup */}
      {selectedTenementData && (
        <GeoJSON
          onEachFeature={(feature, layer) => {
            onEachFeature(feature, layer, true);
          }}
          key={hash(selectedTenementData)}
          pane="overlayPane"
          zIndex={340}
          data={selectedTenementData}
        />
      )}
    </>
  );
};

export default MapLayers;
